<template>
  <fieldset class="selector-modo">
    <legend>Modo de selección:</legend>
    <div class="options-container">
      <label class="option-label">
        <input 
          type="radio" 
          :value="false" 
          :checked="!value" 
          @change="$emit('input', false)" 
        />
        Dibujar en el mapa
      </label>
      <label class="option-label">
        <input 
          type="radio" 
          :value="true" 
          :checked="value" 
          @change="$emit('input', true)" 
        />
        Usar capa existente
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'GeoprocesoSelectorModo',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.selector-modo {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 4px 10px;
  margin-bottom: 4px;
  background: rgba(255, 255, 255, 0.3);
}

.selector-modo legend {
  font-size: 0.8em;
  font-weight: 600;
  color: #444;
  padding: 0 5px;
  width: auto;
  margin-bottom: 0;
  border: none;
}

.options-container {
  display: flex;
  gap: 12px;
  padding: 2px 0;
}

.option-label {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
  cursor: pointer;
  font-size: 0.85em;
  color: #555;
  transition: color 0.2s;
}

.option-label:hover {
  color: #000;
}

.option-label input {
  margin: 0;
  cursor: pointer;
}
</style>
